import React from 'react';
import FooterSection from '../../Common/FooterSection'
import MenuSection from '../../Common/MenuSection'
import styled from "styled-components";
import { SubMenuSection } from './menuSection';
import { HeroSection } from './heroSection';
import config from '../../config';

import { withCookies, Cookies } from 'react-cookie';
import { CookiesPopup } from '../../Common/Cookiespopup';
import Modal from 'react-modal';
import { isTab } from '../../Utils/Utils';

//Static Data sued for rendering Tab Labels
const TabData = [
    {
        id: 1, name: "REPORTS & FILING", bgColor: '#fff', hashValue: 'reports-and-filing', subMenuTabData: [
            { id: 99, key: 'subMenuTabData1_0', name: 'DISCLOSURES UNDER REGULATION 46 OF SEBI LODR', bgColor: '#fff', hashValue: 'disclosures-46', },
            { id: 1, key: 'subMenuTabData1_1', name: 'Annual Report', bgColor: '#fff', hashValue: 'annual-report', },
            { id: 2, key: 'subMenuTabData1_2', name: 'Quarterly reports', bgColor: '#fff', hashValue: 'quarterly-reports', },
            { id: 3, key: 'subMenuTabData1_3', name: 'SEC Filing', bgColor: '#fff', hashValue: 'sec-filing', },
            { id: 4, key: 'subMenuTabData1_4', name: 'MoA and AoA', bgColor: '#fff', hashValue: 'moa-and-aoa', },
            { id: 5, key: 'subMenuTabData1_5', name: '40th Annual General Meeting', bgColor: '#fff', hashValue: 'annual-general-meeting', },
            { id: 6, key: 'subMenuTabData1_6', name: 'Sustainability Reports', bgColor: '#fff', hashValue: 'sustainability-reports', },
            { id: 7, key: 'subMenuTabData1_7', name: 'Other ESG Reports', bgColor: '#fff', hashValue: 'other-esg-reports', },
        ]
    },
    {
        id: 2, name: "INVESTOR MEET", bgColor: '#fff', hashValue: 'investor-meet', subMenuTabData: [
            { id: 1, key: 'subMenuTabData2_1', name: 'Earnings Call', bgColor: '#fff', hashValue: 'earnings-call', },
            { id: 2, key: 'subMenuTabData2_2', name: 'Investor Decks', bgColor: '#fff', hashValue: 'investor-decks', },
            { id: 3, key: 'subMenuTabData3_3', name: 'Investor Meeting Details', bgColor: '#fff', hashValue: 'investor-meeting-details', },
            { id: 4, key: 'subMenuTabData3_4', name: 'Other Investor Calls', bgColor: '#fff', hashValue: 'investor-day-2022', },
        ]
    },
    {
        id: 3, name: "SHARES", bgColor: '#fff', hashValue: 'shares', subMenuTabData: [
            { id: 1, key: 'subMenuTabData3_1', name: 'Share Price', bgColor: '#fff', hashValue: 'share-price', },
            { id: 2, key: 'subMenuTabData3_2', name: 'Equity & Dividend History', bgColor: '#fff', hashValue: 'equity-and-divident-history', },
            { id: 3, key: 'subMenuTabData3_3', name: 'Unpaid & Unclaimed Dividend', bgColor: '#fff', hashValue: 'unpaid-and-unclaimed-divident', },
            { id: 4, key: 'subMenuTabData3_4', name: 'Analyst Coverage', bgColor: '#fff', hashValue: 'analyst-coverage', },
            { id: 5, key: 'subMenuTabData3_5', name: 'Shareholding Pattern', bgColor: '#fff', hashValue: 'shareholding-pattern', },
            { id: 6, key: 'subMenuTabData3_6', name: 'Share Transfer Information', bgColor: '#fff', hashValue: 'share-transfer-information', },
            { id: 7, key: 'subMenuTabData3_7', name: 'Buyback', bgColor: '#fff', hashValue: 'buyback', },
            { id: 8, key: 'subMenuTabData3_8', name: 'IEPF Details', bgColor: '#fff', hashValue: 'details-of-shares', },
        ]
    },
    {
        id: 4, name: "GOVERNANCE", bgColor: '#fff', hashValue: 'governance', subMenuTabData: [
            { id: 1, key: 'subMenuTabData4_1', name: 'Internal Control Systems', bgColor: '#fff', hashValue: 'internal-control-systems', },
            { id: 2, key: 'subMenuTabData4_2', name: 'Committees of the Board', bgColor: '#fff', hashValue: 'committees-of-the-board', },
            { id: 3, key: 'subMenuTabData4_3', name: 'Code of Business Conduct and Ethics (COBE)', bgColor: '#fff', hashValue: 'code-of-business-conduct-and-ethics', },
            { id: 4, key: 'subMenuTabData4_4', name: 'Ombudsperson Reporting', bgColor: '#fff', hashValue: 'ombudsperson-reporting', url: 'https://secure.ethicspoint.eu/domain/media/en/gui/107510/index.html' },
            { id: 5, key: 'subMenuTabData4_5', name: 'Ombudsperson Policy', bgColor: '#fff', hashValue: 'ombudsperson-policy', url: "https://www.drreddys.com/cms/cms/sites/default/files/2021-12/Ombudsperson.pdf" },
            { id: 6, key: 'subMenuTabData4_6', name: 'Third party Code of Conduct', bgColor: '#fff', hashValue: 'third-party-code-of-conduct', url: `${config.serverUrl.imageBase + config.serverUrl.imageUrlPrefix}files/static/supplier-code-of-conduct-new.pdf` },
            { id: 7, key: 'subMenuTabData4_7', name: 'Compliance with NYSE', bgColor: '#fff', hashValue: 'compliance-with-nyse', },
            { id: 8, key: 'subMenuTabData4_8', name: 'Information to Stakeholders', bgColor: '#fff', hashValue: 'information-to-stakeholders', },
            { id: 9, key: 'subMenuTabData4_9', name: 'Corporate Governance Reports', bgColor: '#fff', hashValue: 'corporate-governance-reports', },
            { id: 10, key: 'subMenuTabData4_10', name: 'Policies and Documents', bgColor: '#fff', hashValue: 'policies-and-documents', },
            { id: 11, key: 'subMenuTabData4_11', name: 'Data Privacy', bgColor: '#fff', hashValue: 'data-privacy-notice', url: `/privacy-policy` },
            { id: 12, key: 'subMenuTabData4_12', name: 'Certificates', bgColor: '#fff', hashValue: 'certificates' },
            { id: 13, key: 'subMenuTabData4_13', name: 'Social Media Community Guidelines', bgColor: '#fff', hashValue: 'social-media-community-guidelines' },
        ]
    },
    {
        id: 5, name: "INVESTOR SERVICES", bgColor: '#fff', hashValue: 'investor-services', subMenuTabData: [
            { id: 1, key: 'subMenuTabData5_1', name: 'Amalgamation', bgColor: '#fff', hashValue: 'amalgamation', },
            { id: 2, key: 'subMenuTabData5_2', name: 'Statutory Communication', bgColor: '#fff', hashValue: 'statutory-communication', },
            { id: 3, key: 'subMenuTabData5_3', name: 'Shareholder’s Contacts', bgColor: '#fff', hashValue: 'shareholders-contacts', },
            { id: 4, key: 'subMenuTabData5_4', name: 'Shareholder Information', bgColor: '#EDEDED', hashValue: 'shareholder-information', },
            { id: 6, key: 'subMenuTabData5_6', name: 'Investor Handbook', bgColor: '#fff', hashValue: 'investor-handbook', },
            { id: 7, key: 'subMenuTabData5_7', name: 'Other Stock Exchange Intimations', bgColor: '#fff', hashValue: 'other-stock-exchange-intimations', },
            { id: 8, key: 'subMenuTabData5_8', name: 'Credit Rating', bgColor: '#fff', hashValue: 'credit-rating', },
            { id: 9, key: 'subMenuTabData5_9', name: "Investor’s Complaints / grievances", bgColor: '#fff', hashValue: 'complaints', },
        ]
    },
    {
        id: 6, name: 'ESG PROFILE', bgColor: '#fff', hashValue: 'esg-profile', subMenuTabData: [], url: 'https://bit.ly/3LkDIVJ'
    }
]

const getTabDataIndexByHash = {
    'reports-and-filing': 0,
    'investor-meet': 1,
    'shares': 2,
    'governance': 3,
    'investor-services': 4,
}

const getSubTabDataIndexByHash = {
    'disclosures-46': 0,
    'annual-report': 1,
    'quarterly-reports': 2,
    'sec-filing': 3,
    'moa-and-aoa': 4,
    'annual-general-meeting': 5,
    'sustainability-reports': 6,
    'other-esg-reports': 7,
    'earnings-call': 0,
    'investor-decks': 1,
    'investor-meeting-details': 3,
    'investor-day-2022': 4,
    'share-price': 0,
    'equity-and-divident-history': 1,
    'unpaid-and-unclaimed-divident': 2,
    'analyst-coverage': 3,
    'shareholding-pattern': 4,
    'share-transfer-information': 5,
    'buyback': 6,
    'details-of-shares': 7,
    'internal-control-systems': 0,
    'committees-of-the-board': 1,
    'code-of-business-conduct-and-ethics': 2,
    'ombudsperson-reporting': 3,
    'ombudsperson-policy': 4,
    'third-party-code-of-conduct': 5,
    'compliance-with-nyse': 6,
    'information-to-stakeholders': 7,
    'corporate-governance-reports': 8,
    'policies-and-documents': 9,
    'data-privacy-notice': 10,
    'certificates': 11,
    'social-media-community-guidelines': 12,
    'amalgamation': 0,
    'statutory-communication': 1,
    'shareholders-contacts': 2,
    'shareholder-information': 3,
    'investor-handbook': 4,
    'other-stock-exchange-intimations': 5,
    'credit-rating': 6,
    'complaints': 7
}

const scripts = [
    { loading: fetch("/webflow_javascript/jquery-3.5.1.min.js").then(body => body.text()), isAsync: false, lastOne: false },
    { loading: fetch("/webflow_javascript/dr-reddy.js").then(body => body.text()), isAsync: false, lastOne: false },
    { loading: Promise.resolve("document.addEventListener(\"DOMContentLoaded\",()=>{document.querySelectorAll(\".menu-button\").forEach(e=>{e.addEventListener(\"click\",function(){this.x=((this.x||0)+1)%2,this.x?document.querySelectorAll(\"body\").forEach(e=>e.classList.add(\"no-scroll\")):document.querySelectorAll(\"body\").forEach(e=>e.classList.remove(\"no-scroll\"))})})});"), isAsync: false, lastOne: true },
]

const MainContainer = styled.div`
    position: relative;
    z-index: 1;
    width: 100vw;
    background-color: #fff;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px 30px;
    background-color: #EDEDED;
    width:680px;
    @media (max-width: 820px) {
        width:300px;
    }
`;

const customStyles = {
    content: {
        borderRadius: "5px",
        inset: "10px",
        border: 0,
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        backgroundColor: 'transparent',
    },
    overlay: {
        zIndex: 9999,
        width: "100%",
        height: "100%",
        backgroundColor: "rgb(51 51 51 / 50%)"
    }
};

const customStylesTab = {
    content: {
        borderRadius: "5px",
        inset: "10px",
        border: 0,
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        backgroundColor: 'transparent',
    },
    overlay: {
        zIndex: 9999,
        width: "100%",
        height: "100%",
        backgroundColor: "rgb(51 51 51 / 50%)"
    }
};

const customStylesMob = {
    content: {
        borderRadius: "5px",
        inset: "10px",
        border: 0,
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        backgroundColor: 'transparent',
    },
    overlay: {
        zIndex: 9999,
        width: "100%",
        height: "100%",
        backgroundColor: "rgb(51 51 51 / 50%)"
    }
};
const Img = styled.img`
    height: 18px;
    width: 18px;
    @media (max-width: 820px) {
        height: 15px;
        width: 15px;
    }
`;

class InvesterView extends React.Component {

    constructor(props) {
        super();
        let getHashData = props.location.hash.split('#');
        const sTab = props.location.hash && props.location.hash.length && getHashData.length > 1 && getTabDataIndexByHash.hasOwnProperty(getHashData[1]) ? TabData[getTabDataIndexByHash[getHashData[1]]] : TabData[0];
        const sSubTab = sTab?.name && getHashData.length === 3 && getSubTabDataIndexByHash.hasOwnProperty(getHashData[2]) ? sTab.subMenuTabData[getSubTabDataIndexByHash[getHashData[2]]] : sTab.subMenuTabData[0];
        this.state = {
            selectedTab: sTab,
            selectedSubTab: sSubTab,
            renderPageBool: false,
            cookieBool: true,
            popup: false
        }
    }


    componentDidMount() {
        const htmlEl = document.querySelector('html')
        htmlEl.dataset['wfPage'] = '60952b8da0e26580fc1fde12'
        htmlEl.dataset['wfSite'] = '60952b8da0e265187c1fde0e'

        scripts.concat(null).reduce((active, next) => Promise.resolve(active).then((active) => {
            const loading = active.loading.then((script) => {
                new Function(`
              with (this) {
                eval(arguments[0])
              }
            `).call(window, script)

                return next
            })
            if (active.lastOne) {
                this.setState({ renderPageBool: true })
            }

            return active.isAsync ? next : loading
        }))

        /* const closeOnEscape = (e) => {
            if (e.keyCode == 27 ) {
                this.setState({ popup: false });
            }
        }

        window.addEventListener("keyup", closeOnEscape); */
    }

    render() {

        const { cookies } = this.props;
        const { cookieBool } = this.state;
        var cookiesAcceptanceBool = cookies.get('EnableCookie') || { enable: false };

        return (
            <span>
                <style dangerouslySetInnerHTML={{
                    __html: `
          @import url(/webflow_css/normalize.css);
          @import url(/webflow_css/components.css);
          @import url(/webflow_css/dr-reddy.css);

          @media (min-width:992px) {html.w-mod-js:not(.w-mod-ix) [data-w-id=\"297ee33e-956e-0144-0dda-5feaaa0b38ce\"] {opacity:0;-webkit-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 40px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"6af3a72d-77d1-6f66-2016-e9ac4666fc32\"] {-webkit-transform:translate3d(0, 0, 0) scale3d(1, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 0, 0) scale3d(1, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 0, 0) scale3d(1, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 0, 0) scale3d(1, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"f310ebf6-8ae9-1d03-d2e5-ef3c0cd40578\"] {display:none;}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"0b4d8531-0a89-fecc-d301-c36927da109e\"] {-webkit-transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"205462a9-d649-00ae-41e3-d53ce1b40472\"] {-webkit-transform:translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"aa62f39b-59a8-be68-5678-77b179e6571e\"] {width:0%;}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"7f63f200-4735-055f-ef29-ec1de8b73d69\"] {width:0%;}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"67293bb8-4d73-a363-87cf-9350b4573968\"] {width:0%;}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"3925ae23-4a5d-89ae-c7f0-b8369e164a4e\"] {width:0%;}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"8408ad78-cf8c-a7a3-ec79-852199b2e9f1\"] {width:0%;}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"ab8118c3-5d0c-f14a-7820-4f33a90b67b6\"] {width:0%;}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"6b1b712b-9d3d-b2ce-aae3-2a17d1f1d5b3\"] {width:0%;}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"8ad4bb93-59e3-ec5e-2dc0-d41335835e63\"] {width:0%;}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"4faef0df-bc8a-51fc-6392-217069a7b600\"] {opacity:0;}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"d93819cf-ea4b-1cfb-63c1-d780a0a254ca\"] {-webkit-transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"85d68a56-476f-7846-384c-e8278098bfbc\"] {-webkit-transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"b4bf86e9-b4b9-8a9b-b938-62dcc59edabe\"] {-webkit-transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);}}@media (max-width:991px) and (min-width:768px) {html.w-mod-js:not(.w-mod-ix) [data-w-id=\"0b4d8531-0a89-fecc-d301-c36927da109e\"] {-webkit-transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"205462a9-d649-00ae-41e3-d53ce1b40472\"] {-webkit-transform:translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"aa62f39b-59a8-be68-5678-77b179e6571e\"] {width:0%;}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"7f63f200-4735-055f-ef29-ec1de8b73d69\"] {width:0%;}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"67293bb8-4d73-a363-87cf-9350b4573968\"] {width:0%;}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"3925ae23-4a5d-89ae-c7f0-b8369e164a4e\"] {width:0%;}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"8408ad78-cf8c-a7a3-ec79-852199b2e9f1\"] {width:0%;}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"ab8118c3-5d0c-f14a-7820-4f33a90b67b6\"] {width:0%;}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"6b1b712b-9d3d-b2ce-aae3-2a17d1f1d5b3\"] {width:0%;}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"8ad4bb93-59e3-ec5e-2dc0-d41335835e63\"] {width:0%;}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"4faef0df-bc8a-51fc-6392-217069a7b600\"] {opacity:0;}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"d93819cf-ea4b-1cfb-63c1-d780a0a254ca\"] {-webkit-transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"85d68a56-476f-7846-384c-e8278098bfbc\"] {-webkit-transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"b4bf86e9-b4b9-8a9b-b938-62dcc59edabe\"] {-webkit-transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-moz-transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);-ms-transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);transform:translate3d(0, -1076px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0);}html.w-mod-js:not(.w-mod-ix) [data-w-id=\"f310ebf6-8ae9-1d03-d2e5-ef3c0cd40578\"] {display:none;}}@media (max-width:767px) and (min-width:480px) {html.w-mod-js:not(.w-mod-ix) [data-w-id=\"f310ebf6-8ae9-1d03-d2e5-ef3c0cd40578\"] {display:none;}}@media (max-width:479px) {html.w-mod-js:not(.w-mod-ix) [data-w-id=\"f310ebf6-8ae9-1d03-d2e5-ef3c0cd40578\"] {display:none;}}


          	body {
            	overflow-x: hidden;
            }
          	 .founder-scroll-wrapper::-webkit-scrollbar,
            		.delivering-health-wrapper::-webkit-scrollbar,
            		.side-headlines-wrapper::-webkit-scrollbar {
               width: 2px;
           	}
          	.founder-scroll-wrapper::-webkit-scrollbar-track {
               background-color: rgba(255, 255, 255, .35);
               -webkit-border-radius: 4px;
               border-radius: 4px;
           	}
           	.founder-scroll-wrapper::-webkit-scrollbar-thumb {
               -webkit-border-radius: 4px;
               border-radius: 4px;
               background: #fff;
           	}
            	.delivering-health-wrapper::-webkit-scrollbar-track, .side-headlines-wrapper::-webkit-scrollbar-track {
               background-color: rgba(0, 0, 0, .35);
               -webkit-border-radius: 4px;
               border-radius: 4px;
           	}
           	.delivering-health-wrapper::-webkit-scrollbar-thumb, .side-headlines-wrapper::-webkit-scrollbar-thumb {
               -webkit-border-radius: 4px;
               border-radius: 4px;
               background: #ff5046;
           	}
            .drag-section-circle {
             -webkit-backdrop-filter: blur(5px);
            	backdrop-filter: blur(10px);
            }
            .drag-section-circle {pointer-events: none;}
            .drag-slider-wrapper::-webkit-scrollbar {
               height: 3px;
           	}
          	.drag-slider-wrapper::-webkit-scrollbar-track {
               background-color: rgba(0, 0, 0, .35);
               -webkit-border-radius: 4px;
               border-radius: 4px;
           	}
           	.drag-slider-wrapper::-webkit-scrollbar-thumb {
               -webkit-border-radius: 4px;
               border-radius: 4px;
               background: #000;
           	}
            .w-slider-dot {
              margin: 0 12px;
              background-color: rgba(82,37,181,0.30);
            }
            .w-slider-dot.w-active {
              background-color: rgba(82,37,181,0.80);
            }
        ` }} />
                <Modal
                    isOpen={this.state.popup}
                    style={window.matchMedia('(max-width: 767px)').matches ? customStylesMob : isTab ? customStylesTab : customStyles}
                >
                    <Container>
                        <a onClick={(e) => {
                            e.preventDefault();
                            this.setState({ popup: false });
                        }} style={{ alignSelf: 'flex-end', textDecoration: 'none', cursor: 'pointer' }} >
                            <Img loading="lazy" src='/images/closePrimary.svg' />
                        </a>
                        <a href='https://services.choruscall.in/DiamondPassRegistration/register?confirmationNumber=4085539&linkSecurityString=1bdc5f535b' target="_blank">
                            <img src='/images/Q3FY25_Earnings.jpg' style={{ maxWidth: "100%" }} />
                        </a>
                    </Container>
                </Modal>
                <div>
                    {!this.state.renderPageBool && <span style={{ width: "100vw", height: "100vh", backgroundColor: '#fff', position: 'absolute', zIndex: 99999 }} ></span>}
                    <span id="back-to-top" className="af-view">
                        <div>
                            <MenuSection scrollTopBuffer={100} />
                            <MainContainer>
                                <HeroSection state={this.state} updateState={(changeState) => this.setState(changeState)} />
                                <SubMenuSection tabData={TabData} state={this.state} updateState={(changeState) => this.setState(changeState)} />
                            </MainContainer>
                            <div className="af-class-section af-class-knowledge-bank" style={{ padding: 0, margin: 0 }} >
                                <a href="#back-to-top" data-w-id="1e93b0bc-4d73-ee38-8cbc-f2757ef7c754" className="af-class-back-to-top-wrapper w-inline-block">
                                    <div className="af-class-back-top-top-circle"><img src="/images/chevron-right.svg" loading="lazy" alt className="af-class-top-arrow af-class-black" /><img src="/images/Path-237.svg" loading="lazy" style={{ display: 'none' }} alt className="af-class-top-arrow af-class-white" /></div>
                                    <div>Back to Top</div>
                                </a>
                            </div>
                            {/* {!(cookiesAcceptanceBool?.enable && cookiesAcceptanceBool.enable) && cookieBool && <CookiesPopup setCookeAccpet={(data) => {
                                const { cookies } = this.props;
                                cookies.set('EnableCookie', JSON.stringify(data));
                            }} setCookieBool={(bool) => { this.setState({ cookieBool: bool }) }} />} */}
                            <FooterSection />
                        </div>
                    </span>
                </div>
            </span>
        )
    }
}

export default withCookies(InvesterView)
